import React, { useState } from "react";
import { Alert, Box, Button, Container, TextField, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router";
import currency from "currency.js";

export default function KeyInDiscountEntry(props) {
  const { amount } = props;
  const navigate = useNavigate();

  const [error, setError] = useState("");

  const setAmount = (val) => {
    props.onChange(currency(val, { fromCents: true }).value);
  };

  const getButton = (key) => {
    return (
      <Button
        variant="contained"
        onClick={(e) => {
          if (key === "⌫") {
            setAmount(`${currency(amount).intValue}`.slice(0, -1));
          } else {
            const newAmount = `${currency(amount).intValue}${key}`;
            console.log(newAmount);
            setAmount(newAmount);
          }
        }}
        sx={{
          height: "5rem",
          width: "100%",
          minWidth: "5rem",
          fontWeight: "700",
          fontSize: "2rem",
          backgroundColor: "#DEDEDE",
          color: "#333",
          "&:hover": {
            backgroundColor: "#DEDEDE",
          },
        }}
      >
        {key}
      </Button>
    );
  };

  const getQuickPickButton = (value) => {
    return (
      <Button
        variant="contained"
        onClick={(e) => {
          if (value === "C") {
            setAmount("");
          } else {
            setAmount(currency(value, { fromCents: true }).intValue);
          }
        }}
        sx={{
          height: "5rem",
          width: "7rem",
          fontSize: "1.3rem",
          backgroundColor: "#CECECE",
          color: "#333",
          "&:hover": {
            backgroundColor: "#CECECE",
          },
        }}
      >
        {value === "C" ? "C" : currency(value, { fromCents: true, precision: 2 }).format()}
      </Button>
    );
  };

  const quickPicks = [];

  return (
    <Container maxWidth="sm">
      <Box py={2}>
        {error && (
          <Box>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
        <Box>
          <Box textAlign="center" sx={{ borderBottom: "2px solid #DDD" }}>
            <Typography sx={{ fontSize: "2.5rem" }}>{currency(amount).format()}</Typography>
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {[7, 8, 9].map((num) => getButton(num))}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {[4, 5, 6].map((num) => getButton(num))}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {[1, 2, 3].map((num) => getButton(num))}
          </Box>
          <Box mt={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {["⌫", 0, "00"].map((num) => getButton(num))}
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
